function init() {
    const cards = document.querySelectorAll(".animation-card");

    const observerOptions = {
        threshold: 0.3
    };

    const observerCallback = entries => {
        entries.forEach(entry => {
            const card = entry.target;

            if (entry.isIntersecting) {
                if (!card.classList.contains("visible")) {
                    const index = [...cards].indexOf(card);
                    const delay = index * 100;

                    card.style.transition = `all 0.3s ease-out ${delay}ms`;
                    card.classList.add("visible");
                }
            } else {
                const rect = card.getBoundingClientRect();
                const isScrollingUp = rect.top > 0;

                if (isScrollingUp) {
                    card.style.transition = "none";
                    card.classList.remove("visible");
                    card.style.transitionDelay = "0ms";
                }
            }
        });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    cards.forEach(card => observer.observe(card));
}

export default { init };
